import MSGService from "../services/MSGService";
import { to } from "../../utils";
export default class MSGManager {

  msgService: any;

  constructor() {
    this.msgService = new MSGService();
  }
  getLatestChatChannel = async ({ apiToken, userId } = {}) => {
    let params: any = {};
    if (userId) {
      params.user_id = userId;
    }
    
    const [error, response, network] = await to(
      this.msgService.getLatestChatChannel({ params, apiToken })
    );
    return [response, error, network];
  };
  getChatChannelMessageList = async ({
    apiToken,
    chatChannelId,
    last,
    cancelToken
  } = {}) => {
    let params: any = {};
    if (last) {
      params.last = last;
    }
    
    const [error, response, network] = await to(
      this.msgService.getChatChannelMessageList({ params, apiToken, chatChannelId, cancelToken })
    );
    return [response, error, network];
  };
  getMessageFromURL = async ({ apiToken, url } = {}) => {
    let params: any = {};
    
    const [error, response, network] = await to(
      this.msgService.getMessageFromURL({ params, apiToken, url })
    );
    return [response, error, network];
  };
  postChatChannelMessage = async ({
    apiToken,
    content,
    contentType,
    chatChannelId,
    contentFile,
    divisionId
  } = {}) => {
    let params: any = {};
    let data: any = {};
    if (content) {
      data.content = content;
    }
    if (contentType) {
      data.content_type = contentType;
    }
    if (contentFile) {
      data.content_file = contentFile;
    }
    
    const [error, response, network] = await to(
      this.msgService.postChatChannelMessage({ params, apiToken, data, chatChannelId, divisionId })
    );
    return [response, error, network];
  };
  postReadMessage = async ({ apiToken, chatChannelId } = {}) => {
    let params: any = {};
    let data: any = {};
    
    const [error, response, network] = await to(
      this.msgService.postReadMessage({ params, apiToken, data, chatChannelId })
    );
    return [response, error, network];
  };
  postUpdateSubscription = async ({ apiToken, device_id, subscription } = {}) => {
    let params: any = {};
    let data: any = {};
    if (subscription && device_id) {
      data.device_token = JSON.stringify(subscription);
      data.unique_id = device_id;
      data.device_id = device_id;
      data.device_name = device_id;
      data.device_type = 4;
      data.application = "ishealth";
    }
    
    const [error, response, network] = await to(
      this.msgService.postUpdateSubscription({ params, apiToken, data })
    );
    return [response, error, network];
  };
}
